module.exports = __webpack_public_path__ + "static/media/dsr_ico_career.cbc2ead5.svg";